// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-card-header p {
    margin: 0;
}

.customer-card-header .phone {
    color: #DA512D;
}

.policyThumb li img {
    height: 200px;
    padding: 4px 0;
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    background-color: #dfe7ed;
    border-radius: 5px;
    margin-bottom: 10px;
}

.policyThumb li p {
    margin: 0;
}

.cutomer-action-btn li button {
    color: rgba(0, 0, 0, 0.6);
}

.policyThumb li .date {
    color: #98bcd5;
}

.profilePreview {
    width: 180px;
    height: 180px;
    border: 1px solid #ccc;
    border-radius: 5px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}

.profilePreview img {
    width: 100%;
}

.logoFileBtn {
    position: relative;
    bottom: 15px;
    color: #98bcd5;
    font-size: 16px;
}

tr.policy .pdfLink {
    display: none;
}

tr.policy:hover .pdfLink {
    display: block;
}

tr.mat-header-row {
    border-bottom: 1px solid #000 !important;
}

.civilCardImage {
    width: 90%;
    box-shadow: 0 0 4px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/secure/customer-detail/customer-detail.component.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,yHAAyH;IACzH,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;AACA,40EAA40E","sourcesContent":[".customer-card-header p {\n    margin: 0;\n}\n\n.customer-card-header .phone {\n    color: #DA512D;\n}\n\n.policyThumb li img {\n    height: 200px;\n    padding: 4px 0;\n    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n    background-color: #dfe7ed;\n    border-radius: 5px;\n    margin-bottom: 10px;\n}\n\n.policyThumb li p {\n    margin: 0;\n}\n\n.cutomer-action-btn li button {\n    color: rgba(0, 0, 0, 0.6);\n}\n\n.policyThumb li .date {\n    color: #98bcd5;\n}\n\n.profilePreview {\n    width: 180px;\n    height: 180px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n}\n\n.profilePreview img {\n    width: 100%;\n}\n\n.logoFileBtn {\n    position: relative;\n    bottom: 15px;\n    color: #98bcd5;\n    font-size: 16px;\n}\n\ntr.policy .pdfLink {\n    display: none;\n}\n\ntr.policy:hover .pdfLink {\n    display: block;\n}\n\ntr.mat-header-row {\n    border-bottom: 1px solid #000 !important;\n}\n\n.civilCardImage {\n    width: 90%;\n    box-shadow: 0 0 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
